import { TextInput as ArthurTextInput } from '@arthur/ui'
import { ReactNode } from 'react'
import { FieldValues, useController, UseControllerProps } from 'react-hook-form'
import { useIntl } from 'react-intl'

interface TextInputProps<T extends FieldValues> extends UseControllerProps<T> {
	isDisabled?: boolean
	isRequired?: boolean
	label?: string
	onChange?: (value: string | undefined) => void
	placeholder?: string
	startAdornment?: ReactNode
}

/**
 * Text input
 * @param control
 * @param isDisabled
 * @param isRequired
 * @param name
 * @param label
 * @param onChange
 * @param placeholder
 * @param rules
 * @param startAdornment
 * @constructor
 */
const TextInput = <T extends FieldValues>(
	{
		control,
		isDisabled,
		isRequired,
		label,
		name,
		onChange,
		placeholder,
		rules,
		startAdornment
	}: TextInputProps<T>
) => {
	const { formatMessage } = useIntl()
	const { field, fieldState: { error } } = useController({
		control,
		name,
		rules: {
			...rules,
			required: isRequired
		}
	})

	return (
		<ArthurTextInput
			label={label}
			value={field.value}
			onChange={(value) => {
				if (onChange) {
					onChange(value)
				}
				field.onChange(value?.slice(0, rules?.maxLength as number))
			}}
			placeholder={placeholder}
			prefix={startAdornment}
			errorText={!!error ? formatMessage({ id: `global.errors.${error.type}` }) : undefined}
			disabled={isDisabled}
		/>
	)
}

export default TextInput
